"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorManagerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var ValidatorManagerFactory = /** @class */ (function (_super) {
    __extends(ValidatorManagerFactory, _super);
    function ValidatorManagerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    ValidatorManagerFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    ValidatorManagerFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    ValidatorManagerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    ValidatorManagerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    ValidatorManagerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return ValidatorManagerFactory;
}(contracts_1.ContractFactory));
exports.ValidatorManagerFactory = ValidatorManagerFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'stakingContract',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'validator',
                type: 'address',
            },
        ],
        name: 'Delegation',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'uint32',
                name: 'month',
                type: 'uint32',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
        ],
        name: 'NRTReceived',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '_amount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_base',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_premiumFactor',
                type: 'uint256',
            },
        ],
        name: 'getAdjustedAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'getCommission',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
        ],
        name: 'getDelegationShare',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
        ],
        name: 'getDelegatorByAddress',
        outputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'stakingContract',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'withdrawn',
                        type: 'bool',
                    },
                ],
                internalType: 'struct IValidatorManager.Delegator',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_validatorIndex',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_delegatorIndex',
                type: 'uint256',
            },
        ],
        name: 'getDelegatorByIndex',
        outputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'stakingContract',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'withdrawn',
                        type: 'bool',
                    },
                ],
                internalType: 'struct IValidatorManager.Delegator',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_validatorIndex',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
        ],
        name: 'getDelegatorIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getLuckyValidatorAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getMonthlyNRT',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getTotalAdjustedStakings',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getTotalBlocksSealed',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'getValidatorByAddress',
        outputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'wallet',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'adjustedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'perThousandCommission',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'blocksSealed',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'withdrawn',
                        type: 'bool',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'stakingContract',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'amount',
                                type: 'uint256',
                            },
                            {
                                internalType: 'bool',
                                name: 'withdrawn',
                                type: 'bool',
                            },
                        ],
                        internalType: 'struct IValidatorManager.Delegator[]',
                        name: 'delegators',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct IValidatorManager.Validator',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_validatorIndex',
                type: 'uint256',
            },
        ],
        name: 'getValidatorByIndex',
        outputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'wallet',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'adjustedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'perThousandCommission',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'blocksSealed',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'withdrawn',
                        type: 'bool',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'stakingContract',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'amount',
                                type: 'uint256',
                            },
                            {
                                internalType: 'bool',
                                name: 'withdrawn',
                                type: 'bool',
                            },
                        ],
                        internalType: 'struct IValidatorManager.Delegator[]',
                        name: 'delegators',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct IValidatorManager.Validator',
                name: '',
                type: 'tuple',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'getValidatorEarning',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
        ],
        name: 'getValidatorIndex',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'getValidators',
        outputs: [
            {
                components: [
                    {
                        internalType: 'address',
                        name: 'wallet',
                        type: 'address',
                    },
                    {
                        internalType: 'uint256',
                        name: 'amount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'adjustedAmount',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'perThousandCommission',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'blocksSealed',
                        type: 'uint256',
                    },
                    {
                        internalType: 'bool',
                        name: 'withdrawn',
                        type: 'bool',
                    },
                    {
                        components: [
                            {
                                internalType: 'address',
                                name: 'stakingContract',
                                type: 'address',
                            },
                            {
                                internalType: 'uint256',
                                name: 'amount',
                                type: 'uint256',
                            },
                            {
                                internalType: 'bool',
                                name: 'withdrawn',
                                type: 'bool',
                            },
                        ],
                        internalType: 'struct IValidatorManager.Delegator[]',
                        name: 'delegators',
                        type: 'tuple[]',
                    },
                ],
                internalType: 'struct IValidatorManager.Validator[]',
                name: '',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'initialize',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_seed',
                type: 'uint256',
            },
        ],
        name: 'pickValidator',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_currentNrtMonth',
                type: 'uint32',
            },
        ],
        name: 'receiveNrt',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_sealer',
                type: 'address',
            },
        ],
        name: 'registerBlock',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'bytes',
                name: '_extraData',
                type: 'bytes',
            },
        ],
        name: 'registerDelegation',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'uint256',
                name: '_perThousandCommission',
                type: 'uint256',
            },
        ],
        name: 'setCommission',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
        ],
        name: 'withdrawCommission',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint32',
                name: '_month',
                type: 'uint32',
            },
            {
                internalType: 'address',
                name: '_validator',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '_stakingContract',
                type: 'address',
            },
        ],
        name: 'withdrawDelegationShare',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=ValidatorManagerFactory.js.map